import { createFileRoute } from '@tanstack/react-router';
import { LoyaltyDetailPage } from './LoyaltyDetailPage';

export const Route = createFileRoute('/_protected/admin/loyalty/$loyaltyId/')({
  component: LoyaltyDetailPage,
});
